import React from 'react';
import { LegalDocumentPage } from '@/components/LegalDocumentPage';

const TermsOfUse: React.FC = () => (
  <LegalDocumentPage documentType="terms-of-use" titleKey="terms_of_use.title" />
);

export default TermsOfUse;
